import { throttle } from 'lodash';
import React from 'react';

const SWITCH_DEVICE_THRESHOLDS = [1.3, 1, 0.65];

interface Props {
  setChatClassNames: any;
}

interface State {
  device: string;
  direction: string;
}

export default class WidgetCanvas extends React.Component<Props, State> {
  state = {
      device: 'phone',
      direction: 'portrait',
  };

  componentDidMount() {
    window.addEventListener('resize', throttle(this.resize, 250).bind(this));

    this.resize();
  }

  componentDidUpdate() {
    this.props.setChatClassNames(`${this.state.device}-${this.state.direction}`);
  }

  resize() {
    const ration = window.innerHeight / window.innerWidth;

    if (ration > SWITCH_DEVICE_THRESHOLDS[0]) {
      this.setState({
        device: 'phone',
        direction: 'portrait',
      });
    } else if (ration > SWITCH_DEVICE_THRESHOLDS[1]) {
      this.setState({
        device: 'tablet',
        direction: 'portrait',
      });
    } else if (ration > SWITCH_DEVICE_THRESHOLDS[2]) {
      this.setState({
        device: 'tablet',
        direction: 'landscape',
      });
    } else {
      this.setState({
        device: 'phone',
        direction: 'landscape',
      });
    }
  }

  render() {
    return (
      <>
        <div className="upper-chat-cover" />
        <div className="canvas">
          <img className="canvas" alt="mobile device" src={`images/widget/${this.state.device}_${this.state.direction}.png`} />
          <div className={`blinking-light ${this.state.device}-${this.state.direction}-blinking-light`}>
            <p>Live</p>
            <span />
          </div>
        </div>
        <div className="lower-chat-cover" />
      </>
    );
  }
}
